// import { ImageConfig, layoutConfig, optionSectionConfig, RichTextConfig, textBoxSectionConfig, RectangleConfig, LineConfig } from './sampleConfig';
import { ArrowConfig } from './layout-template/arrowConfig';
import {  Section, TextSection } from './components/sections/TextSection';
import { RichTextSection } from './components/sections/RIchTextSection';
import { ImageSection } from './components/sections/ImageSection';
import { OptionsSection } from './components/sections/OptionsSection';
import { TextBoxSection } from './components/sections/TextBoxSection';
import { LineSection } from './components/sections/LineSection';
import { ArrowSection } from './components/sections/ArrowSection';
import { RectangleConfig } from './layout-template/rectangleConfig';
import { ImageConfig } from './layout-template/imageConfig';
import { RichTextConfig } from './layout-template/richTextConfig';
import { optionSectionConfig } from './layout-template/optionSectionConfig';
import { textBoxSectionConfig } from './layout-template/textBoxConfig';
import { LineConfig } from './layout-template/lineConfig';
import './toolbox.css';
export interface IToolboxConfig {
  name: string;
  type: string;
  iconClass: string;
}
const defaultToolboxConfig: IToolboxConfig[] = [
  {
    name:"Rectangle",
    type: "rectangle",
    iconClass: "lb-icon-rectangle"
  },
  {
    name:"Rich Text",
    type: "richText",
    iconClass: "lb-icon-rich-text"
  },
  {
    name:"Image",
    type: "image",
    iconClass: "lb-icon-image"
  },
  {
    name:"Options",
    type: "option",
    iconClass: "lb-icon-options"
  },
  {
    name:"TextBox",
    type: "textbox",
    iconClass: "lb-icon-textbox"
  },
  {
    name:"Arrow",
    type: "arrow",
    iconClass: "lb-icon-arrow"
  },
  {
    name:"Line",
    type: "line",
    iconClass: "lb-icon-line"
  },

]
export class ToolboxManager {
  private host: HTMLElement;
  private tools: Section[] = [];

  constructor(host: HTMLElement) {
    this.host = host;
    this.tools = [];
  }

  public addTool(tool: Section,toolConfig:IToolboxConfig): void {
    const toolbox = this.host;
    const toolDiv = document.createElement('div');
    toolDiv.title= toolConfig.name;
    toolDiv.draggable = true;
    (toolDiv as any)['sectionObj'] = (tool as any).clone();
    toolDiv.classList.add("toolbox-drag-item");
    const iconDiv =  document.createElement('div');
    iconDiv.classList.add(toolConfig.iconClass);
    toolDiv.appendChild(iconDiv);
    toolDiv.addEventListener('dragstart', (e) => {
      e.dataTransfer?.setData('text/plain', JSON.stringify({ name: tool.name, type: tool.type }));
    });
    toolbox.appendChild(toolDiv);
    this.tools.push(tool);
  }

  public addDefaultTools(){
    defaultToolboxConfig.forEach(toolConfig => {
      let tool = this.getConfigFromType(toolConfig.type);
      if(tool){
        this.addTool(tool, toolConfig);
      }
    });
  }

  public destroy(): void {
    // Clean upss
    this.host.remove();
  }

  public getConfigFromType(type: string): Section | null {
    switch (type) {
      case 'rectangle':
      case 'text':
        return new TextSection(RectangleConfig);
      case 'image':
        return new ImageSection(ImageConfig);
      case 'richText':
        return new RichTextSection(RichTextConfig);
      case 'option':
        return new OptionsSection(optionSectionConfig);
      case 'textbox':
        return new TextBoxSection(textBoxSectionConfig);
      case 'line':
        return new LineSection(LineConfig);
      case 'arrow':
        return new ArrowSection(ArrowConfig);
      default:
        return null;
    }
  }
}


export const getToolFromType = (type: string): Section | null => {
  // switch (type) {
  //   case 'text':
  //     return new Section('Text', 'text', 60, 60, 0, 0);
  //   case 'image':
  //     return new Section('Image', 'image', 60, 60, 0, 0);
  //   default:
  //     return null;
  // }
  return null
}
